import AllApis from "app/Apis/apis";
import {SINGLE_MARKET_EXECUTIVE_FAILED, SINGLE_MARKET_EXECUTIVE_REQUEST, SINGLE_MARKET_EXECUTIVE_SUCCESS } from "app/utils/constants/MarketExecutiveConstant"
import { Axios } from "index";

export const getSingleMarketExecutive = ()=>{
  return async (dispatch)=>{
    try {
      dispatch({type:SINGLE_MARKET_EXECUTIVE_REQUEST});
      const {data} = await Axios.get(AllApis?.marketExective?.getById());
      dispatch({type:SINGLE_MARKET_EXECUTIVE_SUCCESS,payload:{
        data:data
      }})
    } catch (error) {
      dispatch({type:SINGLE_MARKET_EXECUTIVE_FAILED,payload: error?.response?.data?.message});
    }
  }
}